import React from 'react';

import DropDownButton from 'components/form/DropDownButton';
import LoginWrapper from 'components/auth/LoginWrapper';

export default function () {
    return (
        <DropDownButton className="strong" label={gettext('Sign In')}>
            <LoginWrapper />
        </DropDownButton>
    );
}



// WEBPACK FOOTER //
// ./source/containers/SiteHeaderBar/SignInDropDown.jsx